import { RouteTabs, type RouteTabItem } from '@/components/ui/route-tabs';
import { useLanguage } from '@/i18n/language-hooks';
import { useRoutePrefetch } from '@/lib/queryPrefetch';

type BankingTab = 'accounts' | 'transactions';

/** Pillar-level tab strip for the Banking views. */
export function BankingTabs({ active }: { active: BankingTab }) {
  const { t } = useLanguage();
  const prefetch = useRoutePrefetch();

  const items: RouteTabItem[] = [
    { id: 'accounts', to: '/banking/accounts', label: t('banking.tabs.accounts') },
    { id: 'transactions', to: '/banking/transactions', label: t('banking.tabs.transactions') },
  ];

  return (
    <RouteTabs
      ariaLabel={t('banking.tabs.label')}
      activeId={active}
      items={items}
      onPrefetch={prefetch}
    />
  );
}
